import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import './Products.css';

const Products = () => {
  const [products, setProducts] = useState([]);
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const collectionFilter = searchParams.get('collection');

  useEffect(() => {
    fetchCollections();
    fetchProducts();
  }, [collectionFilter]);

  const fetchCollections = async () => {
    try {
      const response = await fetch('http://localhost:5000/api/collections');
      if (response.ok) {
        const data = await response.json();
        setCollections(data);
      }
    } catch (error) {
      console.error('Failed to fetch collections:', error);
    }
  };

  const fetchProducts = async () => {
    try {
      let url = 'http://localhost:5000/api/products';
      if (collectionFilter) {
        url += `?collectionId=${collectionFilter}`;
      }
      
      const response = await fetch(url);
      if (response.ok) {
        const data = await response.json();
        setProducts(data);
      }
    } catch (error) {
      console.error('Failed to fetch products:', error);
    } finally {
      setLoading(false);
    }
  };

  const getCollectionName = (collectionId) => {
    const collection = collections.find(c => c.id === parseInt(collectionId));
    return collection ? collection.name : null;
  };

  if (loading) {
    return (
      <div className="products-page">
        <div className="loading">Loading products...</div>
      </div>
    );
  }

  const currentCollection = collectionFilter ? getCollectionName(collectionFilter) : null;

  return (
    <div className="products-page">
      <div className="products-header">
        <h1>{currentCollection || 'All Products'}</h1>
        <p className="products-subtitle">
          {currentCollection 
            ? `Explore our ${currentCollection.toLowerCase()} collection`
            : 'Discover our handcrafted creations'}
        </p>
      </div>

      <div className="products-filter">
        <Link 
          to="/products" 
          className={`filter-btn ${!collectionFilter ? 'active' : ''}`}
        >
          All Products
        </Link>
        {collections.map(collection => (
          <Link
            key={collection.id}
            to={`/products?collection=${collection.id}`}
            className={`filter-btn ${collectionFilter === String(collection.id) ? 'active' : ''}`}
          >
            {collection.name}
          </Link>
        ))}
      </div>

      {products.length === 0 ? (
        <div className="no-products">
          <p>No products available yet.</p>
          <p>Check back soon for new items!</p>
        </div>
      ) : (
        <div className="products-grid">
          {products.map(product => (
            <Link 
              key={product.id} 
              to={`/products/${product.slug}`}
              className="product-card"
            >
              {product.image && (
                <div className="product-image">
                  <img src={product.image} alt={product.name} />
                  {product.featured && (
                    <span className="featured-badge">Featured</span>
                  )}
                </div>
              )}
              <div className="product-details">
                <h3>{product.name}</h3>
                {product.description && (
                  <p className="product-description">
                    {product.description.length > 100 
                      ? `${product.description.substring(0, 100)}...` 
                      : product.description}
                  </p>
                )}
                <div className="product-footer">
                  <span className="product-price">${parseFloat(product.price).toFixed(2)}</span>
                  {product.stock > 0 ? (
                    <span className="in-stock">In Stock</span>
                  ) : (
                    <span className="out-of-stock">Out of Stock</span>
                  )}
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default Products;
